module.exports = __webpack_public_path__ + "static/media/LOS_image.35d30e5f.png";